module.exports = __webpack_public_path__ + "img/entertainment-m-2.1171e64f.jpg";